import { render, staticRenderFns } from "./SingleLayout.vue?vue&type=template&id=35974562&scoped=true"
import script from "./SingleLayout.vue?vue&type=script&lang=js"
export * from "./SingleLayout.vue?vue&type=script&lang=js"
import style0 from "./SingleLayout.vue?vue&type=style&index=0&id=35974562&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35974562",
  null
  
)

export default component.exports